import { render, staticRenderFns } from "./CustomSelectMenu.vue?vue&type=template&id=9096a7a4&scoped=true&"
import script from "./CustomSelectMenu.vue?vue&type=script&lang=ts&"
export * from "./CustomSelectMenu.vue?vue&type=script&lang=ts&"
import style0 from "./CustomSelectMenu.vue?vue&type=style&index=0&id=9096a7a4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9096a7a4",
  null
  
)

export default component.exports